import { useState } from 'react';
import { zipSync } from 'fflate';
import { getShipmentPdf } from '@/api/client';
import { ConfirmWindow } from '@/components/MaintenanceForm';
import { ShipmentPrintDialog } from './ShipmentPrintDialog';
import type { ShipmentListItem } from './types';

export function ShipmentBatchDocuments({ items, onClose }: { items: ShipmentListItem[]; onClose: () => void }) {
  const [preparing, setPreparing] = useState(false);
  const [printAt, setPrintAt] = useState<number | null>(null);
  const download = async () => {
    setPreparing(true);
    try {
    const files: Record<string, Uint8Array> = {}; let bytes = 0;
    for (const [index, item] of items.entries()) {
      const pdf = await getShipmentPdf(item.id);
      const data = new Uint8Array(await pdf.arrayBuffer()); bytes += data.length;
      if (bytes > 100 * 1024 * 1024) throw new Error('文件合计超过 100 MB，请减少选择后重试');
      const name = item.shipmentNo.replace(/[^a-zA-Z0-9_-]/g, '_');
      files[`${index + 1}-${name}.pdf`] = data;
    }
    const zipped = zipSync(files, { level: 0 });
    const url = URL.createObjectURL(new Blob([new Uint8Array(zipped)], { type: 'application/zip' }));
    const anchor = document.createElement('a'); anchor.href = url; anchor.download = '发货单-批量.zip'; anchor.click();
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
    onClose();
    } finally { setPreparing(false); }
  };
  if (printAt !== null) return <ShipmentPrintDialog key={items[printAt].id} item={items[printAt]} groups={null} onClose={() => printAt + 1 < items.length ? setPrintAt(printAt + 1) : onClose()} />;
  return <ConfirmWindow title={`所选 ${items.length} 张发货单`} confirm="下载 PDF 压缩包" disabled={!items.length || items.length > 30} onClose={onClose} onConfirm={download}>
    <p>最多一次选择 30 个批次。下载前逐份核对访问权限；任一文件失败时整包停止。</p>
    <p>{items.map((item) => item.shipmentNo).join('、')}</p>
    <button type="button" onClick={() => setPrintAt(0)} disabled={!items.length || preparing}>逐张预览、分享或打印</button>
  </ConfirmWindow>;
}
